/**
 * Detects which GraphQL variable a free-text reprocess target belongs to.
 *
 * - An Instagram URL (containing `instagram.com/`) -> { postUrl }
 * - An all-digits string -> { mentionId }
 * - Anything else -> { shortcode }
 *
 * Caveat: an all-digit shortcode is indistinguishable from a mention ID; for
 * this internal-only tool that tradeoff is acceptable.
 */
export interface ReprocessTarget {
  mentionId?: string;
  shortcode?: string;
  postUrl?: string;
}

export function detectReprocessTarget(input: string): ReprocessTarget {
  const value = (input || '').trim();
  if (!value) {
    return {};
  }
  if (/instagram\.com\//i.test(value)) {
    return { postUrl: value };
  }
  if (/^\d+$/.test(value)) {
    return { mentionId: value };
  }
  return { shortcode: value };
}
